// extracted by mini-css-extract-plugin
export default {"session":"reports_session__8Pjj+","addReport":"reports_addReport__GMbVO"};